import { 
  changeBomSaved,
  importBomSuccess,
  updateBomStatus,
  updateBomPrices,
  updateBomQuoteProgress,
  updateUnquotedBomLineItems,
  requestStart,
  requestFailure,
  requestEnd, 
} from "../bomSlice"

import { 
  createBom,
  doQuoteBomStatus,
 } from "pu-actions/bomQuote"

import { QUOTING_BOM_PARTS, QUOTED } from "../data/BomStatus"

import { selectDataForQuoteToApi } from "../selector/selectors"
import { buildBomLineItems } from "../utils/builders"
import { hasBomLineItemQuoteFinished } from "../utils/helpers"
import { findBomErrors } from "../utils/checkers"

export const importBom = () => async (dispatch, getState) => {
  dispatch(requestStart())

  const {
    first_row,
    name,
    board_qtys,
    quote_type,
    revision,
    bom_parameters,
    workbook,
    initial_selected_board_qty,
    } = selectDataForQuoteToApi(getState())

  const body = {
    bom: {
      name,
      revision,
      board_qtys: board_qtys.toString(),
      quote_type: quote_type,
      origin: 'api',
      bom_line_items: buildBomLineItems(bom_parameters, workbook, first_row),
    }
  }

  const bom_errors = findBomErrors(body.bom.bom_line_items)
  let error_message = bom_errors.rd_duplicates.length > 0 || bom_errors.mpn_duplicates.length > 0 ? "We found errors in your BOM. Please fix them before proceeding.\n" : ""
  if (bom_errors.rd_duplicates.length > 0) {
    bom_errors.rd_duplicates.forEach((rd_dup) => {
      error_message += `Duplicate Reference Designator ${rd_dup.rd} in lines`
      rd_dup.bom_line_items.forEach((bli, idx) => {
        error_message += ` ${first_row + bli.idx}`
        if(idx < rd_dup.bom_line_items.length - 1) error_message += ","
        if(idx == rd_dup.bom_line_items.length - 1) error_message += ".\n"
      })
    })
  }

  if (bom_errors.mpn_duplicates.length > 0) {
    bom_errors.mpn_duplicates.forEach((mpn_dup) => {
      error_message += `Duplicate Manufacturer Part Number ${mpn_dup.mpn} in lines`
      mpn_dup.bom_line_items.forEach((bli, idx) => {
        error_message += ` ${first_row + bli.idx}`
        if(idx < mpn_dup.bom_line_items.length - 1) error_message += ","
        if(idx == mpn_dup.bom_line_items.length - 1) error_message += ".\n"
      })
    })
  }

  if(error_message && error_message != "") {
    alert(error_message)
    dispatch(requestFailure(error_message))
    return
  }

  try {
    const response = await createBom(body)
    const { bom } = response.data
    dispatch(importBomSuccess({ bom, initial_selected_board_qty }))
    dispatch(requestEnd())

    const n = bom.bom_line_items.length
    let bom_status = bom.bom_status.toUpperCase()
    let unquoted_parts = bom.bom_line_items.length
    let quoted_parts = []
    const bom_id = bom.id

    if (bom_status == QUOTING_BOM_PARTS) {
      dispatch(updateBomQuoteProgress({
        step: n - unquoted_parts,
        total_steps: n,
        current_pn: bom.bom_line_items[0].mpn
      }))

      do {
        await new Promise(r => setTimeout(r, 1000 * 5));
        try {
          const response = await doQuoteBomStatus(bom_id)
          if (response.status >= 400) continue;
          const { bom } = response.data
          bom_status = bom.bom_status.toUpperCase()
          const bom_line_items = bom.bom_line_items.filter(bli => !quoted_parts.includes(bli.id) && hasBomLineItemQuoteFinished(bli))
          if (bom_line_items.length == 0) continue;
          bom_line_items.forEach((bli) => quoted_parts.push(bli.id))
          unquoted_parts -= bom_line_items.length
          dispatch(updateBomQuoteProgress({
            step: n - unquoted_parts,
            total_steps: n,
            current_pn: bom_line_items[bom_line_items.length - 1].mpn
          }))
          dispatch(updateUnquotedBomLineItems({ bom_line_items: bom_line_items }))
        } catch (err) {
          console.log(err)
        }

      } while (bom_status == QUOTING_BOM_PARTS || unquoted_parts > 0)

      if (bom_status == QUOTED && unquoted_parts <= 0) {
        dispatch(updateBomStatus(QUOTED))
        dispatch(updateBomPrices())
      }
    }
    dispatch(changeBomSaved(false))
  } catch (err) {
    console.log(err)
    dispatch(requestFailure(`Couldn't create BOM`))
  }
}